import React from "react";
import SelectableList from "./SelectableList";
import { useAppContext } from "../../helpers/account-context";
import { cleanAvailableTags } from "../../helpers/helper";

const TagSelector = (props) => {
  const { filters, onChangeFilters } = props;
  const { initedData: {enabledTags, hiddenFilters}, account: { tags }, getLocale } = useAppContext()
  // https://codepen.io/smithsuth/pen/VvYzZP
  const isHidden = !!hiddenFilters && (hiddenFilters.indexOf('tags') >= 0 || hiddenFilters.indexOf('all') >= 0);
  if(isHidden) return null;

  const tagOptions = cleanAvailableTags(tags, enabledTags);
  if(!tagOptions || tagOptions.length === 0) return null;

  return (
    <SelectableList
      title={filters.tags && filters.tags.length > 0 ? `${getLocale("tags")} (${filters.tags.length})` : getLocale("tags")}
      items={tagOptions}
      selectedItems={filters.tags || []}
      isMulti={true}
      onChange={(newTags) => onChangeFilters({ ...filters, tags: newTags })}
    />
  )
};

export default TagSelector;
